/* eslint-disable max-lines */
/* eslint-disable camelcase */
/* eslint-disable max-depth */
/* eslint-disable operator-linebreak */
/* eslint-disable max-statements */
/* eslint-disable no-magic-numbers */

export default {
    'searchList': {
        'searchTxt': [
            {
                'name': '订单号',
                'value': 'customerOrderNo',
                'type': 'input',
                'unfold': true,
                'span': 4
            }, {
                'name': '创建时间',
                'value': 'createTime',
                'type': 'time',
                'unfold': true,
                timeNum: 61,
                'span': 7,
                'startPlaceholder': '创建开始时间',
                'endPlaceholder': '创建结束时间'
            }, {
                'name': '投诉渠道',
                'value': 'adviceChannel',
                'type': 'select',
                'unfold': true,
                'span': 4,
                'optionNum': 'ADVICE_CHANNEL',
                'multiple': false
            }
        ],
        'unfoldState': false,
        'advancedBtn': true
    },
    'table':
    {
        'clickState': false,
        'selectBtn': true,
        'height': 400,
        'columns': [
            {
                'label': '订单号',
                'prop': 'customerOrderNo',
                width: 150
            },
            {
                'label': '订单创建时间',
                'prop': 'createTime',
                width: 150
            },
            {
                'label': '分公司',
                'prop': 'companyName',
                width: 120
            },
            {
                'label': '平台',
                'prop': 'siteName',
                width: 120
            },
            {
                'label': '仓库名称',
                'prop': 'whName',
                width: 120
            },
            {
                'label': '投诉渠道',
                'prop': 'adviceChannelName',
                width: 120
            },
            {
                'label': '投诉类型',
                'prop': 'adviceTypeName',
                width: 120
            },
            {
                'label': '业务类型',
                'prop': 'businessTypeName',
                width: 100
            },
            {
                'label': '承运商',
                'prop': 'carrierName',
                width: 120
            },
            {
                'label': '司机',
                'prop': 'driver',
                width: 120
            },
            {
                'label': '车牌号',
                'prop': 'vehicleCard',
                width: 120
            },
            {
                'label': '运单号',
                'prop': 'waybillNo',
                width: 150
            },
            {
                'label': '发车单号',
                'prop': 'dispatchNo',
                width: 150
            },
            {
                'label': '紧急程度',
                'prop': 'emergencyLevelName',
                width: 120
            },
            {
                'label': '客户名称',
                'prop': 'customerName',
                width: 220
            },
            {
                'label': '收货详细地址',
                'prop': 'receiverDetailAddr',
                width: 300
            },
            {
                'label': '收货人',
                'prop': 'receiverName',
                width: 120
            },
            {
                'label': '收货人联系方式',
                'prop': 'receiverMobile',
                width: 120
            }
        ]
    },
    searchTotalTitle: [
        {
            name: '投诉类型',
            value: 'adviceType',
            type: 'select',
            optionNum: 'ADVICE_TYPE'
        },
        {
            name: '车牌号',
            value: 'vehicleCard',
            type: 'input'
        },
        {
            name: '司机',
            value: 'driver',
            type: 'input'
        },
        {
            name: '紧急程度',
            value: 'emergencyLevel',
            type: 'select',
            optionNum: 'EMERGENCY_LEVEL'
        },
        {
            name: '运单号',
            value: 'waybillNo',
            type: 'input'
        },
        {
            name: '业务类型',
            value: 'businessType',
            type: 'select',
            optionNum: 'BUSINESS_TYPE'
        }
    ],
    'page': {
        'layout': 'total, sizes, prev, pager, next, jumper',
        'pageSize': 10,
        'pageSizes': [10, 20, 30, 50, 100]
    }
};
